import React, { useState, useEffect } from 'react';
import '../styles/onboardingFlow/mainAuthWrapper.scss';
import Slide1 from './slides/Slide1';
import Login from './login/Login';
import SignUp from './signUp/SignUp';
import ForgotPassword from './forgotPassword/ForgotPassword';
import ResetPassword from './resetPassword/ResetPassword';
import Slide2 from './slides/Slide2';
import Slide3 from './slides/Slide3';
import Slide4 from './slides/Slide4';
import { useLocation } from 'react-router-dom';

const MainAuthWrapper = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const slides = [Slide1, Slide2, Slide3, Slide4];
  const location = useLocation();
  const isSignUpRoute = location.pathname === '/register';
  const isForgotPasswordRoute = location.pathname === '/forgot-password';
  const isResetPasswordRoute = location.pathname === '/reset-password';

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 5000); // 5 seconds

    return () => clearInterval(interval);
  }, [slides.length]);

  // Always render the slides + auth combo
  // The right side content (Login, SignUp, ForgotPassword, or ResetPassword component) will change based on route
  const renderRightContent = () => {
    if (isSignUpRoute) {
      return <SignUp />;
    } else if (isForgotPasswordRoute) {
      return <ForgotPassword />;
    } else if (isResetPasswordRoute) {
      return <ResetPassword />;
    } else {
      return <Login />;
    }
  };

  return (
    <div className='mainAuthWrapper'>
      <div className='mainAuthWrapper__left'>
        {slides.map((SlideComponent, index) => (
          <div
            key={index}
            className={`mainAuthWrapper__slide ${
              index === currentSlide ? 'mainAuthWrapper__slide--active' : ''
            }`}
          >
            <SlideComponent />
          </div>
        ))}
      </div>
      <div className='mainAuthWrapper__right'>{renderRightContent()}</div>
    </div>
  );
};

export default MainAuthWrapper;
